$(document).ready(function() {
    $(document).on('click', '.js-pre-order-info-button', function() {
        $(".js-pre-order-info").addClass('show');
    });
    $(document).on('click', '.js-pre-order-info-close', function() {
        $(".js-pre-order-info").removeClass('show');
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/main/info.js